import React from 'react'
import { Link, useHistory } from 'react-router-dom'
import { SaveButton } from './save'

const SaveCancel = ({to = '/dashboard/profile', saveText = 'Save', ...props}) => {
  const history = useHistory()

  return (
    <div className="flex flex-wrap items-center mb-5 lg:mb-8" {...props}>
      <div className="w-full md:w-auto lg:w-auto">
        <SaveButton mobileClassname="mb-5" saveText={saveText} onClick={() => history.push(to)}/>
      </div>
      <div className="w-full md:w-auto lg:w-auto text-center lg:text-left">
        <Link to={to} className="px-8 text-gray-444 underline text-xs lg:text-sm">Cancel</Link>
      </div>
    </div>
  )
}

export { SaveCancel }
